import { Controller } from "@hotwired/stimulus"
import {
  isLessonReleased,
  lessonHasVideos,
  lessonVideos,
  renderVideoInto,
} from "../helpers/lesson_media"

// data-controller="lesson"
export default class extends Controller {
  static targets = ["shell"]

  connect() {
    $("#popup").modal("show")
  }

  async hidePopup(event) {
    const courseId = event.currentTarget.id.split("-")[1]

    await fetch(`/user_course_popups?course_id=${courseId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })

    $("#popup").modal("hide")
  }

  async newLesson(event) {
    const lessonId = event.currentTarget.parentElement.id.split("-")[1]

    this._lessonLoadToken = (this._lessonLoadToken || 0) + 1
    const loadToken = this._lessonLoadToken

    const response = await fetch(`/lessons/${lessonId}`, {
      method: "GET",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      cache: "no-store",
    })

    const payload = JSON.parse(await response.text())

    if (loadToken !== this._lessonLoadToken) return

    this.updateCoreLesson(payload)
    this.dispatch("loaded", { detail: payload })
    this.refreshVideos(payload)
    this.applyLessonPlayer(payload)
    this.scrollToTablist()
  }

  refreshVideos(lesson) {
    const shell = document.querySelector(".main-content-lesson")
    if (!shell) return

    const videosController = window.Stimulus?.getControllerForElementAndIdentifier(
      shell,
      "lessons--videos"
    )

    if (videosController) {
      videosController.update({ detail: lesson })
      return
    }

    shell.dispatchEvent(new CustomEvent("lessons--videos:update", { detail: lesson }))
  }

  updateCoreLesson(lesson) {
    const title = document.querySelector(".title-lesson-current")
    const matterTitle = document.querySelector(".title-matter-current")
    const nowLesson = document.querySelector("#now-lesson")

    if (!title || !nowLesson) return

    title.textContent = lesson.title

    if (matterTitle) {
      matterTitle.textContent = lesson.matter_title || ""
      matterTitle.hidden = !lesson.matter_title
    }

    document
      .querySelectorAll(".lesson-item.lesson-item--active")
      .forEach((item) => item.classList.remove("lesson-item--active"))

    const lessonElement = document.querySelector(`#lesson-${lesson.id}`)
    lessonElement?.classList.add("lesson-item--active")

    clearInterval(this.intervalo)
    nowLesson.setAttribute("data-lesson", `now-${lesson.id}`)

    if (!isLessonReleased(lesson)) {
      nowLesson.innerHTML = ""
      nowLesson.removeAttribute("data-video")
      this.renderLockedLesson(nowLesson, lesson)
      this.renderCompletionButton(lesson.attended)
    } else if (!lessonHasVideos(lesson)) {
      nowLesson.innerHTML = ""
      nowLesson.removeAttribute("data-video")
      this.renderLessonIntro(lesson)
      this.renderCompletionButton(lesson.attended)
    }
  }

  applyLessonPlayer(lesson) {
    if (!isLessonReleased(lesson) || !lessonHasVideos(lesson)) return

    this.renderMainPlayer(lesson)
  }

  renderMainPlayer(lesson) {
    const videos = lessonVideos(lesson)
    const video = videos[0]
    const player = document.getElementById("now-lesson")
    const title = document.querySelector("[data-lessons--videos-target='title']")

    if (title && video?.title) title.textContent = video.title

    if (!renderVideoInto(player, video, lesson)) {
      this.renderLessonIntro(lesson)
      this.renderCompletionButton(lesson.attended)
      return
    }

    this.renderVideoCompletionButton(video.attended)
  }

  renderVideoCompletionButton(attended) {
    const area = document.querySelector(".area-btn-completed")
    if (!area) return

    const action = attended ? "lessons--progress#uncompleteVideo" : "lessons--progress#completeVideo"
    const text = attended ? "Desmarcar" : "Marcar"

    area.innerHTML = `
      <button class="btn btn-completed-video" data-action="${action}">
        ${text} como assistido
      </button>
    `
  }

  renderLessonIntro(lesson) {
    if (!lesson.videos?.length) {
      const nowLesson = document.querySelector("#now-lesson")
      nowLesson.innerHTML = `<img class="img-fluid" alt="${lesson.course_title}" src="${lesson.course_image}" style="width: 100%;">`
    }
  }

  renderLockedLesson(nowLesson, lesson) {
    nowLesson.insertAdjacentHTML(
      "beforeend",
      `
      <img class="img-fluid" alt="${lesson.course_title}" src="${lesson.course_image}" style="width: 100%;">
      <div class="timer position-absolute w-100 h-100 d-flex justify-content-center flex-column align-items-center">
        <h3>Aula liberada em breve</h3>
        <div class="timer-container">
          ${["Dias", "Horas", "Minutos", "Segundos"]
        .map(
          (label, index) => `
              <div class="timer-section">
                <span class="time-${label.toLowerCase()}">0</span>
                <label>${label}</label>
              </div>
            `
        )
        .join("")}
        </div>
      </div>
    `
    )

    this.intervalo = setInterval(() => {
      const release = new Date(lesson.release_date)
      const now = new Date()
      const diff = Math.max(release - now, 0)

      if (diff === 0) {
        clearInterval(this.intervalo)
        return
      }

      const seconds = Math.floor(diff / 1000) % 60
      const minutes = Math.floor(diff / (1000 * 60)) % 60
      const hours = Math.floor(diff / (1000 * 60 * 60)) % 24
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))

      try {
        document.querySelector(".time-dias").innerHTML = String(days).padStart(2, "0")
        document.querySelector(".time-horas").innerHTML = String(hours).padStart(2, "0")
        document.querySelector(".time-minutos").innerHTML = String(minutes).padStart(2, "0")
        document.querySelector(".time-segundos").innerHTML = String(seconds).padStart(2, "0")
      } catch (error) {
        console.error(error)
        clearInterval(this.intervalo)
      }
    }, 1000)
  }

  renderCompletionButton(attended) {
    const area = document.querySelector(".area-btn-completed")
    const action = attended ? "lesson:uncomplete" : "lesson:complete"
    const text = attended ? "Desmarcar" : "Marcar"

    area.innerHTML = `
      <button class="btn btn-completed-video" data-action="${action}">
        ${text} como assistido
      </button>
    `
  }

  scrollToTablist() {
    const nav = document.getElementById("lesson-tablist-nav")
    if (!nav) return

    const getScrollParent = (el) => {
      let p = el.parentElement
      while (p) {
        const style = window.getComputedStyle(p)
        const overflowY = style.overflowY
        if ((overflowY === "auto" || overflowY === "scroll") && p.scrollHeight > p.clientHeight) {
          return p
        }
        p = p.parentElement
      }
      return window
    }

    const scroller = getScrollParent(nav)

    const doScroll = () => {
      const bottomMargin = 8

      if (scroller === window) {
        const navRect = nav.getBoundingClientRect()
        const viewportBottom = window.innerHeight - bottomMargin
        const delta = navRect.bottom - viewportBottom
        if (Math.abs(delta) < 2) return

        const targetTop = Math.min(
          Math.max(0, window.pageYOffset + delta),
          document.documentElement.scrollHeight - window.innerHeight
        )

        window.scrollTo({ top: targetTop, left: 0, behavior: "smooth" })
      } else {
        const navRect = nav.getBoundingClientRect()
        const scrollerRect = scroller.getBoundingClientRect()
        const viewportBottom = scrollerRect.bottom - bottomMargin
        const delta = navRect.bottom - viewportBottom
        if (Math.abs(delta) < 2) return

        const targetTop = Math.min(
          Math.max(0, scroller.scrollTop + delta),
          scroller.scrollHeight - scroller.clientHeight
        )

        scroller.scrollTo({ top: targetTop, left: 0, behavior: "smooth" })
      }
    }

    requestAnimationFrame(() => requestAnimationFrame(doScroll))
    setTimeout(doScroll, 150)
  }

  disconnect() {
    clearInterval(this.intervalo)
  }
}